<template>
  <div>SafariReservationsDetailHistory</div>
</template>

<script>
export default {
  name: 'SafariReservationsDetailHistory'
}
</script>
